import { Button } from "@/components/base/Button.tsx";
import { Link, useNavigate } from "react-router-dom";
import { Tenant } from "@/models";
import { EyeIcon } from "lucide-react";
import { DataTable } from "@/components/datatables/DataTable.tsx";
import { tenantColumns } from "@/components/datatables/tenants/Tenants.Columns.tsx";
import { tenant } from "@/repositories/tenant.ts";
import { useEffect, useState } from "react";

export const TenantTable = () => {
  const navigate = useNavigate();
  const [data, setData] = useState<Tenant[]>([]);

  useEffect(() => {
    tenant.listTenants().then((res) => setData(res));
  }, []);

  const actions = (tenant: Tenant) => {
    const actions = [
      <Button onClick={() => navigate(`/app/${tenant.id}`)} variant="secondary">
        <EyeIcon />
      </Button>,
    ];
    return actions;
  };
  return (
    <div className="p-4 w-full">
      <div className="flex flex-row space-between pb-4">
        <h1 className="text-2xl font-bold ">Tenants</h1>
        <div className="flex flex-grow" />
        <Link to={"create"}>
          <Button>Add Tenant</Button>
        </Link>
      </div>
      <div className="flex flex-wrap gap-2 w-full">
        <DataTable data={data} columns={tenantColumns({ actions })} />
      </div>
    </div>
  );
};
